import React, { useState } from 'react';
import styled from 'styled-components';

import { HEADER_NAV_LINKS, ANCHOR_URLS } from '../constants/navigationLinks';
import { useScrollLock } from '../hooks/useScrollLock';
import BurgerButton from './BurgerButton';
import Links from './Links';
import Button from './Button';

const ContainerStyles = styled.div`
  z-index: 10; // Ensure the nav is above the content
`;

const NavStyles = styled.nav<{ $isOpen: boolean }>`
  background: var(--color-neutral-white);
  box-shadow: var(--box-shadow-subtle);
  border-left: var(--border-default);
  position: fixed;
  right: 0;
  top: 0;
  height: 100vh;
  width: 50vw;
  overflow-y: auto;
  transition: transform 0.3s ease-in-out;
  transform: translateX(${({ $isOpen }) => ($isOpen ? '0' : '100%')});

  ul {
    align-items: center;
    display: flex;
    font-size: var(--heading5-size);
    justify-content: center;
    height: 100%;
  }
`;

const MobileNav: React.FC = () => {
  const [open, setOpen] = useState(false);
  useScrollLock(open);
  const handleClose = () => setOpen(false);

  return (
    <ContainerStyles>
      <NavStyles $isOpen={open}>
        <Links
          links={HEADER_NAV_LINKS}
          gap="large"
          vertical={true}
          buttonStyles={{ colorScheme: 'scheme3' }}
          onClick={handleClose}
        >
          <Button
            href={ANCHOR_URLS.contact}
            text="Contact Me"
            onClick={handleClose}
            colorScheme="scheme2"
          />
        </Links>
      </NavStyles>
      <BurgerButton open={open} setOpen={setOpen} />
    </ContainerStyles>
  );
};

export default MobileNav;
